import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  notAllowed: {
    id: 'PrivateRoute.notAllowed',
    description: 'Toast when user is not allowed on the page',
    defaultMessage: 'Du har inte tillgång till sidan',
  },
});
